import { AnnouncementDetails } from '../models/announcement-detail-model';
import { EmptyData } from '../../../core/models/empty-data';
import { CommonLookupItem } from '../../../shared/models/common-lookup-item.model';
import { CustomerModel } from '../../../customers/shared/models/customer-model';
import { PagingWrapper } from '../../../core/models/paging-wrapper';
import { AnnouncementModel } from '../models/announcement-model';
import { Observable } from 'rxjs';
import { AnnouncementFilterModel } from '../models/announcement-filter-model';
import { PagingFilter } from '../../../shared/models/paging-filter.model';
import { UrlConfigContainer } from '../../../core/url-config';
import { AjaxDataServiceService } from '../../../core/ajax-data-service.service';
import { Injectable } from '@angular/core';
import { FutureAnnouncements } from '../models/future-announcement';
import { NewAjaxDataServiceService } from '../../../core/new-ajax-data.service';
import {
  AnnouncementModerationDetails,
  AnnouncmentModerationRequestViewModel,
} from '../models/announcement-moderation-model';
import { ApiResponse } from '../../../core/api-response';
import { UrlConfigService } from '@hrra/core';

@Injectable({ providedIn: 'root' })
export class AnnouncementService {
  public listAnnouncements(
    filter: PagingFilter<AnnouncementFilterModel>
  ): Observable<PagingWrapper<AnnouncementModel>> {
    return this.ajax.postDataPaging(
      this.urlService.urlConfig.api.data.announcements.list,
      filter.toObject(),
      AnnouncementModel
    );
  }

  public getModerationAnnouncementCount(): Observable<
    ApiResponse<{ totalModerationCount: number }>
  > {
    return this.newAjax.getData(
      this.urlService.urlConfig.api.data.announcements.moderationRelatedAnnouncement
        .announcementStat
    );
  }

  public activateAnnouncement(announcementId: number) {
    return this.ajax.postData(
      this.urlService.format(this.urlService.urlConfig.api.data.announcements.activate, {
        id: announcementId,
      }),
      EmptyData,
      EmptyData
    );
  }

  public approveAnnouncementModeration(announcementModerationId) {
    return this.newAjax.postData(
      this.urlService.format(
        this.urlService.urlConfig.api.data.announcements.moderationRelatedAnnouncement.approve,
        { announcementModerationId: announcementModerationId }
      ),
      {}
    );
  }

  public rejectAnnouncementModeration(announcementModerationId) {
    return this.newAjax.postData(
      this.urlService.format(
        this.urlService.urlConfig.api.data.announcements.moderationRelatedAnnouncement.reject,
        { announcementModerationId: announcementModerationId }
      ),
      {}
    );
  }

  public deactivateAnnouncement(announcementId: number) {
    return this.ajax.postData(
      this.urlService.format(this.urlService.urlConfig.api.data.announcements.deactivate, {
        id: announcementId,
      }),
      EmptyData,
      EmptyData
    );
  }

  public cancelAnnouncement(announcementId: number) {
    return this.ajax.postData(
      this.urlService.format(this.urlService.urlConfig.api.data.announcements.cancel, {
        id: announcementId,
      }),
      EmptyData,
      EmptyData
    );
  }

  public changeAnnouncementCaptureStatus(
    announcementId: number,
    hasCaptureCv: boolean
  ) {
    return this.newAjax.postData(this.urlService.urlConfig.api.data.announcements.capture, {
      HasCaptureCv: hasCaptureCv,
      AnnouncementId: announcementId,
    });
  }

  public getAnnouncementDetails(announcementId: number) {
    return this.newAjax.getData<ApiResponse<AnnouncementDetails>>(
      this.urlService.format(this.urlService.urlConfig.api.data.announcements.details.get, {
        id: announcementId,
      }),
      {}
    );
  }
  public getModerationRelatedAnnouncements(announcementId: number) {
    return this.newAjax.getData<ApiResponse<AnnouncmentModerationRequestViewModel>>(
      this.urlService.format(
        this.urlService.urlConfig.api.data.announcements.moderationRelatedAnnouncement.get,
        { announcementId: announcementId }
      )
    );
  }

  public listFutureAnnouncements(): Observable<
    PagingWrapper<FutureAnnouncements>
  > {
    return this.ajax.getDataPaging(
      this.urlService.format(this.urlService.urlConfig.api.data.announcements.listFuture, null),
      EmptyData,
      FutureAnnouncements
    );
  }

  constructor(
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>,
    private newAjax: NewAjaxDataServiceService
  ) {}
}
